<template>
  <div class="site">
    <div>设置</div>
  </div>
</template>

<script>
export default {
  name: "site",
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>